import { Customer } from '~/data';

const getCustomerRepresentatives = (customer: Pick<Customer, 'representatives'>): string[] => {
  return customer.representatives?.split(',') ?? [];
};

export default getCustomerRepresentatives;
